module.exports = __webpack_public_path__ + "25916beac98ba0bc08833def7916520a.png";